import toCurrency from './toCurrency';

/**
 * A whole amount drops its cents ("$100"); anything else keeps them ("$9.99").
 *
 * For the quiet ends of a range, where a trailing ".00" is only noise; the
 * amounts a reader compares against each other should use `toCurrency` so they
 * share one format.
 */
export default function formatRangeEndAmount(value: number, currencyCode?: string | null): string {
  if (!Number.isInteger(value)) {
    return toCurrency(value, { currencyCode });
  }
  const wholeDigits = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
  const sign = value < 0 ? '-' : '';
  const absValue = Math.abs(value);
  if (!currencyCode || currencyCode === 'USD') {
    return `${sign}$${absValue.toLocaleString(undefined, wholeDigits)}`;
  }
  try {
    return `${sign}${absValue.toLocaleString(undefined, { style: 'currency', currency: currencyCode, ...wholeDigits })}`;
  } catch {
    return `${sign}${absValue.toLocaleString(undefined, wholeDigits)} ${currencyCode}`;
  }
}
